import { Box, Flex } from '@mantine/core';
import { Navigate, useParams } from 'react-router';
import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';
import PageWithSidebar from 'src/UI/page-nav/PageWithSidebar';
import { NonFinancialDataTabs } from '../types';
import Objectives from '../sections/Objectives';
import SavedMemories from '../sections/SavedMemories';
import { buildIndividualNavLinks } from './individualNavLinks';
import PersonalDetailsV2 from './sections/PersonalDetailsV2';
import DependantsV2 from './sections/DependantsV2';
import HealthAndVulnerabilitiesV2 from './sections/HealthAndVulnerabilitiesV2';
import EmploymentV2 from './sections/EmploymentV2';
import EstatePlanningV2 from './sections/EstatePlanningV2';
import RiskAndInvestmentPreferencesV2 from './sections/RiskAndInvestmentPreferencesV2';
import TaxAndAdviceMomentsV2 from './sections/TaxAndAdviceMomentsV2';
import ProfessionalConnectionsV2 from './sections/ProfessionalConnectionsV2';

export default function IndividualDataContentV2() {
  const { clientId } = useCurrentClient();
  const { sectionSlug } = useParams<{ sectionSlug: string }>();

  const personalDetailsUrl = `/client/${clientId}/non-financial-data/${NonFinancialDataTabs.PersonalDetails}`;

  const content = getSectionContent(sectionSlug, personalDetailsUrl);

  return (
    <Flex direction="row" justify="stretch">
      <Box flex={1}>
        <PageWithSidebar
          links={buildIndividualNavLinks(clientId)}
          activeUrl={`/client/${clientId}/non-financial-data/${sectionSlug}`}
          variant="profileV2"
        >
          {content}
        </PageWithSidebar>
      </Box>
    </Flex>
  );
}

function getSectionContent(sectionSlug: string | undefined, personalDetailsUrl: string) {
  switch (sectionSlug) {
    case NonFinancialDataTabs.PersonalDetails:
      return <PersonalDetailsV2 />;
    case NonFinancialDataTabs.Dependants:
      return <DependantsV2 />;
    case NonFinancialDataTabs.HealthAndVulnerabilities:
      return <HealthAndVulnerabilitiesV2 />;
    case NonFinancialDataTabs.Employment:
      return <EmploymentV2 />;
    case NonFinancialDataTabs.Objectives:
      return <Objectives />;
    case NonFinancialDataTabs.EstatePlanning:
      return <EstatePlanningV2 />;
    case NonFinancialDataTabs.RiskAndInvestmentPreferences:
      return <RiskAndInvestmentPreferencesV2 />;
    case NonFinancialDataTabs.TaxAndAdviceMoments:
      return <TaxAndAdviceMomentsV2 />;
    case NonFinancialDataTabs.AdvisorsProfessionalConnections:
      return <ProfessionalConnectionsV2 />;
    case NonFinancialDataTabs.SavedMemories:
      return <SavedMemories />;
    default:
      return <Navigate to={personalDetailsUrl} replace />;
  }
}
